import React from 'react';
// Import Shared Components
import { Search, Button } from 'shared-components';

import SEARCHBY from '../searchby';
import AMOUNTS from '../../../Transfers/components/amountOptions';
import STATUSES from '../statusOptions';
// Import Component Styles
import { SearchContainer, FilterButtonGroup } from './styles';

export default function({
  searchTransactions,
  updateSearchByState,
  updateSearchStatus,
  updateSearchAmount,
  searchBy,
  filterButton,
  toggleSearchFilter,
  resetSearch,
  updateParams,
  params: { amount, status },
}) {
  const searchByAmount = searchBy === 'amount';

  return (
    <SearchContainer>
      <Search
        searchOptions={SEARCHBY}
        updateSearchBy={updateSearchByState}
        searchBy={searchBy}
        onClick={searchTransactions}
        options={searchByAmount ? AMOUNTS : STATUSES}
        updateItem={searchByAmount ? updateSearchAmount : updateSearchStatus}
        selected={searchByAmount ? amount : status}
        dropdown
      />
      {filterButton && (
        <FilterButtonGroup>
          <Button
            variant="text"
            type="primary"
            size="small"
            onClick={toggleSearchFilter}
          >
            Add Filters
          </Button>
          <p>/</p>
          <Button
            variant="text"
            type="primary"
            size="small"
            onClick={resetSearch}
          >
            Reset
          </Button>
        </FilterButtonGroup>
      )}
    </SearchContainer>
  );
};
